// extracted by mini-css-extract-plugin
export var equalColumn = "_g1-0";